export default __webpack_public_path__ + "157bda920b70aabceec8606978638664.png";